import styled from 'styled-components';

export const PasswordRecoveryWrap = styled.section``;
